import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthinsurance-search',
  templateUrl: './healthinsurance-search.component.html',
  styleUrls: ['./healthinsurance-search.component.scss']
})
export class HealthinsuranceSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
